const Flickity = require('flickity');
const Masonry = require('masonry-layout');

export default () => {

    const lists = document.querySelectorAll('.testimonials__list');
    for (const list of lists) {
        if (list.children.length > 1) {
            const flickity = new Flickity(list, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: true
            });
        }
    }

    // now check for masonry
    const grids = document.querySelectorAll('[data-testimonial-grid]');
    for (const grid of grids) {
        const masonry = new Masonry( grid, {
            itemSelector: '.testimonial'
        });
    }

}
